// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl-title--editable {
  cursor: pointer;
  color: rgb(0, 85, 204);
}
.vl-title--editable .vl-icon {
  visibility: hidden;
}
.vl-title--editable:hover {
  text-decoration: underline;
}
.vl-title--editable:hover .vl-icon {
  visibility: visible;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
